import React from 'react'
import PropTypes from 'prop-types'
import { Modal as AntModal } from 'antd'
import Button from '../button/button'
import './modal.scss'

const Modal = ({
  title,
  children,
  open = false,
  width = 520,
  confirmLoading = false,
  maskClosable = true,
  closable = true,
  footer,
  onOk,
  onCancel,
  okText = 'OK',
  cancelText = 'Cancel',
  className = '',
  ...props
}) => {
  const modalClass = `app-modal ${className}`

  return (
    <AntModal
      title={title}
      open={open}
      width={width}
      confirmLoading={confirmLoading}
      maskClosable={maskClosable}
      closable={closable}
      footer={
        footer === undefined
          ? [
              <Button key="cancel" onClick={onCancel}>
                {cancelText}
              </Button>,
              <Button key="submit" type="primary" loading={confirmLoading} onClick={onOk}>
                {okText}
              </Button>
            ]
          : footer
      }
      onOk={onOk}
      onCancel={onCancel}
      className={modalClass}
      {...props}
    >
      {children}
    </AntModal>
  )
}

Modal.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  open: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  confirmLoading: PropTypes.bool,
  maskClosable: PropTypes.bool,
  closable: PropTypes.bool,
  footer: PropTypes.node,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  className: PropTypes.string
}

export default Modal
